module.exports = __webpack_public_path__ + "static/media/salaoDeBeleza.9f51a9f9.svg";